import React, {useReducer} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import WithClickCount from "../../../hocs/withClickCount";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import LookCanvasContext from "../../../lookCanvasContext";
import {updateNavigationCount} from "../../../../../actions/lookFunctions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {PAN_POSITIONS} from "../../../core/constants";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const getPanTranslateId = (position) => {
  switch (position) {
    case "LHO":
    case "L":
      return "grohe.feature.outlet.LHO"
    case "RHO":
    case "R":
      return "grohe.feature.outlet.RHO"
    default:
      return "grohe.feature.placement.C"
  }
}

const GroheFeatureOptionsShowerPan = (props) => {

  const {lookActiveFeature, updateNavigationCount, parentOptionClick, isWizard} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const featureGroup = lookActiveFeature.getParent();

  if (!lookActiveFeature || (featureGroup.partId !== "shower_pan_combo")) {
    return null
  }

  const currentMeta = lookActiveFeature.metaData["layerPosition"];
  if (!currentMeta) {
    return null
  }

  const positionsAvailable = PAN_POSITIONS.filter(position => {
    return !!featureGroup.getMatchingPositionFeature(position, lookActiveFeature);
  });

  if (positionsAvailable.length <= 1) {
    return null
  }

  const optionsButtonClick = (maxClickCountReached, zoomToFeatureGroup, position) => {
    // const featureLabel = (Analytics.getStringForAnalytics(getValueText(option.metaValue))).toLowerCase() + "_" + Analytics.getSkuForAnalytics(lookActiveFeature);
    // const analyticsLabel = IS_PRODUCT_JOURNEY
    //   ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
    //   : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    // Analytics.sendClickEvent(analyticsLabel);
    if ((position === currentMeta) || maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }
    const sameFeature = featureGroup.getMatchingPositionFeature(position, lookActiveFeature);
    if (sameFeature) {
      if (parentOptionClick) {
        parentOptionClick(sameFeature)
      }
      zoomToFeatureGroup(sameFeature.partId, sameFeature, null, !isWizard, true, false); // if wizard - don't change url
      updateNavigationCount();
      forceUpdate();
    }
  };

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <div className="lk-feature__options">
          <span className="lk-feature__options-title">
            <FormattedMessage id="grohe.feature.outlet"/>:
          </span>
          <LookCanvasContext.Consumer>
            {(imageCanvas) => (
              <WithZoomToFeature imageCanvas={imageCanvas}>
                {(zoomToFeatureGroup) => (
                  <div className="lk-feature__options-list">
                    {positionsAvailable.map(position => {
                      const isActive = position === currentMeta;
                      // const disabled = !isActive && !sameFeature;
                      const disabled = false;
                      return (
                        <Button className={"look-button look-button--half-radius look-button--option lk-type"
                          + (isActive ? " look-button--option-active" : "") + (disabled ? " look-button--disabled" : "")}
                                key={position}
                                disabled={disabled}
                                onClick={() => isActive ? null : optionsButtonClick(maxClickCountReached, zoomToFeatureGroup, position)}>
                          <FormattedMessage id={getPanTranslateId(position)}/>
                        </Button>
                      )
                    })}
                  </div>
                )}
              </WithZoomToFeature>
            )}
          </LookCanvasContext.Consumer>
        </div>
      )}
    </WithClickCount>
  )
};

GroheFeatureOptionsShowerPan.propTypes = {
  metaName: PropTypes.string,
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
  isWizard: PropTypes.bool,
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature, featureGroupCount} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
    featureGroupCount, // to update options after all features received
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  updateNavigationCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsShowerPan)
)
